import React, { useState } from 'react';
import { SidebarDirectoryStateless } from './sidebar-directory-stateless';
export function SidebarDirectory({ onSelectDirectory, ...props }) {
    const [selectDirectory, setSelectDirectory] = useState(undefined);
    const handleSelectDirectory = (directory) => {
        setSelectDirectory(directory);
        onSelectDirectory(directory);
    };
    return (React.createElement(SidebarDirectoryStateless, { ...props, onSelectDirectory: handleSelectDirectory, currentDirectory: selectDirectory }));
}
